import React from "react";
import { Warning, Sparkle } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * AnomalyBadge — Bir malzeme kaydında AI anomali tespiti varsa gösterilen rozet.
 * Aynı malzeme adı için sistemdeki median değerlere göre birim fiyat/miktar
 * sapması hesaplanır (backend `list_materials` içinde).
 *
 * props.anomaly: { severity: "medium"|"high", reasons: [...],
 *                  price_median?, price_dev_pct?, price_direction?,
 *                  qty_median?, qty_dev_pct?, qty_direction? }
 */
export default function AnomalyBadge({ anomaly, testId }) {
  if (!anomaly || !anomaly.severity) return null;
  const isHigh = anomaly.severity === "high";
  const palette = isHigh
    ? "border-red-400 bg-red-50 text-red-800 hover:bg-red-100"
    : "border-amber-400 bg-amber-50 text-amber-800 hover:bg-amber-100";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId || "anomaly-badge"}
          data-severity={anomaly.severity}
          className={`inline-flex items-center gap-1 px-1.5 py-0.5 border text-[10px] font-bold uppercase tracking-widest transition-colors ${palette}`}
          title="AI Anomali tespiti — detay için tıklayın"
        >
          <Sparkle size={10} weight="fill" />
          <Warning size={11} weight="fill" />
          Kontrol edin
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 rounded-none sm:rounded-sm p-3">
        <div className="flex items-center gap-1.5 mb-2">
          <Sparkle size={12} weight="fill" className="text-[#4E7A0F]" />
          <span className="text-[10px] uppercase tracking-widest font-bold text-slate-700">
            AI Anomali Tespiti
          </span>
          <span className={`ml-auto text-[9px] font-bold uppercase tracking-widest px-1 py-0.5 ${
            isHigh ? "bg-red-100 text-red-800" : "bg-amber-100 text-amber-800"
          }`}>
            {isHigh ? "Yüksek" : "Orta"}
          </span>
        </div>
        <ul className="space-y-1 text-xs text-slate-700 list-disc pl-4">
          {(anomaly.reasons || []).map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
        <div className="mt-2 pt-2 border-t border-slate-200 text-[10px] text-slate-500">
          Örneklem: {anomaly.sample_size_price || anomaly.sample_size_qty || 0} kayıt.
          Rakamlar yalnızca uyarı amaçlıdır — kayıt doğruysa yok sayabilirsiniz.
        </div>
      </PopoverContent>
    </Popover>
  );
}
